// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__AZweC","containerItemsCenter":"Skeleton_containerItemsCenter__27Xvu"};